export function loginErrorMessage(err) {
  const body = err && err.response && err.response.data;
  const msg = body && body.message;
  if (msg === 'invalid credentials') return '账号或密码错误';
  if (msg === 'username and password are required') return '请输入账号和密码';
  if (msg === 'duplicate username, please contact admin') return '账号重复，请联系管理员指定商户';
  if (msg) return String(msg);
  return '登录失败，请稍后重试';
}
